import Axios from "axios";

export const SelectAllNome = (a, b, c, d, e) => {
  return (dispatch) => {
    Axios.get(
      `https://www.24-crm.tn/webservice/api/Nome?coddos=${a}&serveur=${b}&user=${c}&pwd=${d}&database=${e}`
    ).then((response) => {
      return dispatch({ type: "ALLNOME_SELECT", payload: response.data });
    });
  };
};
